const MIN_VALUE = 0.05;

export const calculateProgress = (value: number, target: number) => {
  return Math.max(MIN_VALUE, value / target);
};
